module.exports = __webpack_public_path__ + "img/logo-znamylekar-turquoise-rgb.cdec4cd4.png";